import React, { Component } from 'react'
import { Flex, Box, Divider, Text } from 'rebass'
import styled from 'styled-components'
import { colors, fonts, fontSizes, fontWeights } from '../theme'
import Textlink from '../elements/Text/TextLink'
import Link from 'gatsby-link'
import {
  EmailIcon,
  TwitterIcon,
  PhoneIcon,
  HomeIcon,
  ChevronRightIcon,
  FacebookBoxIcon,
  TwitterBoxIcon,
  LinkedinBoxIcon,
  GooglePlusBoxIcon,
  RssBoxIcon,
  WebIcon,
} from 'mdi-react'

const Textbox = styled(Box)`
  font-family: ${fonts.primary};
  font-size: ${fontSizes[4] + 'px'};
  font-weight: 700;
  color: white;
`
const TextSeparator = styled(Divider)`
  width: 30px;
  height: 4px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
`
const TextDetails = styled(Text)`
  list-style: none;
  text-align: left;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #7f97ad;
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[1] + 'px'};
`
const Links = styled(Link)`
  color: #7f97ad;
  font-family: ${fonts.secondary};
  font-weight: 500;
  font-size: ${fontSizes[1] + 'px'};
  text-decoration: none;
  margin-top: 10px;
  margin-bottom: 10px;
  &:hover {
    color: ${colors.secondary};
  }
`
const Links2 = styled.a`
  color: #7f97ad;
  font-family: ${fonts.secondary};
  font-weight: 500;
  font-size: ${fontSizes[1] + 'px'};
  text-decoration: none;
  margin-top: 10px;
  margin-bottom: 10px;
  &:hover {
    color: ${colors.secondary};
  }
`

class Footer extends Component {
  render() {
    const { t } = this.props
    return (
      <div
        id="contact"
        style={{
          color: '#7f97ad',
          background: colors.primary,
        }}
      >
        <Flex flexWrap="wrap" flexDirection="row" px={[1, 2, 5, 5]} py={5}>
          <Textbox width={[1, 1, 1 / 2, 1 / 4]} pr={4}>
            <img src="/img/transparent.svg" style={{ height: '46px' }} />
            <Flex display="inline" mt={3}>
              <HomeIcon style={{ minWidth: '20px' }} className="IconBox" />
              <TextDetails>
                1/6242-A Street No. 3 East Rohtash Nagar Shahdara Delhi 110032
              </TextDetails>
            </Flex>
            <Flex display="inline">
              <PhoneIcon className="IconBox" />
              <TextDetails>+91 9911887728</TextDetails>
            </Flex>
            <Flex display="inline">
              <PhoneIcon className="IconBox" />
              <TextDetails>+91 9654121126</TextDetails>
            </Flex>
            <Flex display="inline">
              <PhoneIcon className="IconBox" />
              <TextDetails>+91 9899274720</TextDetails>
            </Flex>
            <Flex display="inline">
              <EmailIcon className="IconBox" />
              <Links2 href="mailto:jshubham0094@gmail.com">
                jshubham0094@gmail.com
              </Links2>
            </Flex>
          </Textbox>
          <Textbox width={[1, 1, 1 / 2, 1 / 4]} pl={[0, 0, 3, 4]}>
            LINKS
            <TextSeparator />
            <Flex display="inline">
              <ChevronRightIcon className="IconBox" />
              <Links to="/#home">Home</Links>
              <br />
            </Flex>
            <Flex display="inline">
              <ChevronRightIcon className="IconBox" />
              <Links to="/services">Our Services</Links>
              <br />
            </Flex>
            <Flex display="inline">
              <ChevronRightIcon className="IconBox" />
              <Links to="/about">About us</Links>
              <br />
            </Flex>
            <Flex display="inline">
              <ChevronRightIcon className="IconBox" />
              <Links to="/articles">Articles</Links>
              <br />
            </Flex>
            <Flex display="inline">
              <ChevronRightIcon className="IconBox" />
              <Links to="/values">Our Values</Links>
              <br />
            </Flex>
            <Flex display="inline">
              <ChevronRightIcon className="IconBox" />
              <Links to="#contactus">Contact Us</Links>
            </Flex>
          </Textbox>
          <Textbox width={[1, 1, 1 / 2, 1 / 4]}>
            SUPPORT
            <TextSeparator />
            <Links to="/team">Our Team</Links>
            <br />
            <Links to="/request">Submit a Request</Links>
            <br />
            <Links to="/#">Visit Knowledge Base</Links>
            <br />
            <Links to="/#">Support System</Links>
            <br />
            <Links to="/#">Refund Policy</Links>
            <br />
            <Flex>
              <Links to="/#">Professional Services</Links>
            </Flex>
          </Textbox>
          <Textbox width={[1, 1, 1 / 2, 1 / 4]}>
            TWITTER FEED
            <TextSeparator />
            <Flex>
              <TextDetails>
                JAIN S N & Co. is a leading firm of Chartered Accountants
                established in 2012.
              </TextDetails>
            </Flex>
            <Flex display="inline">
              <WebIcon
                style={{
                  color: '#198cfa',
                  height: '18px',
                  width: '18px',
                  marginRight: '10px',
                  marginTop: '10px',
                }}
              />
              <Links2 href="https://taxbyjain.com/">www.taxbyjain.com</Links2>
            </Flex>
            <Divider color={colors.secondary} />
            <TextDetails>
              Firm acts as a One-Stop Advisor offering expertise and hands-on
              support.
            </TextDetails>
            <Flex display="inline">
              <TwitterIcon
                style={{
                  color: '#198cfa',
                  height: '18px',
                  width: '18px',
                  marginRight: '10px',
                  marginTop: '10px',
                }}
              />
              <Links2 href="https://twitter.com/shubhamjain" target="_blank">
                @ Shubham Jain
              </Links2>
            </Flex>
          </Textbox>
        </Flex>
        <Flex
          bg="#00152a"
          color="greyDark"
          px={[1, 2, 5, 5]}
          py={3}
          flexDirection={['column', 'row']}
        >
          <Flex width={[1, 1, 1 / 2, 1 / 2]}>
            <TextDetails> &copy; 2018 All Rights Reserved</TextDetails>
          </Flex>
          <Flex
            width={[1, 1, 1 / 2, 1 / 2]}
            justifyContent={['flex-start', 'flex-end']}
            display="inline"
          >
            <TextDetails>Folow us: </TextDetails>
            <FacebookBoxIcon className="IconBox2" />
            <TwitterBoxIcon className="IconBox2" />
            <LinkedinBoxIcon className="IconBox2" />
            <GooglePlusBoxIcon className="IconBox2" />
            <RssBoxIcon className="IconBox2" />
          </Flex>
        </Flex>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js